export default (ctx) => {
  return {
    channel: 'notifications',
    topic: 'bell',
    cb: async (message) => {
      if (!Array.isArray(message.data)) {
        message.data = [message.data];
      }

      message.data.sort();

      for (const msg of message.data) {
        ctx.notificationService.bell(msg);
      }
    },
  };
};
